/* v8 ignore start */
export namespace ErrorUtils {
  export function throwMessage(string: string): never {
    throw new Error(string);
  }

  export function ensureError(error: unknown): Error {
    return error instanceof Error ? error : new Error(String(error));
  }
}
/* v8 ignore stop */
